module.exports = "/_next/static/images/Butch_Wilson-96244e0a2184b27662ed8b46a531cbd3.webp";